import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from 'src/app/_service/leads.service';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AddEditPlanLeadComponent } from '../add-edit-plan-lead/add-edit-plan-lead.component';
import { MemberService } from 'src/app/_service/member.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-plan-lead-list',
  templateUrl: './plan-lead-list.component.html',
  styleUrls: ['./plan-lead-list.component.css']
})
export class PlanLeadListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; planList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles_copy = []; circles = []; circle = '';
  search = ''; submitted: boolean = false; lead_sources: any; lead_source: string; package_type: any; pkg_type = '';

  constructor(private memberapi: MemberService, private dialog: MatDialog, private sharedapi: SharedService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.getcircle();
    this.getLeadSources();
    this.getPackageType();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getLeadSources() {
    this.leadapi.getLeadSources().subscribe((data: any) => {
      if (data.status) {
        this.lead_sources = data.data;
      } else {
        this.lead_sources = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getPackageType() {
    await this.memberapi.getPackageType().subscribe((data: any) => {
      if (data.status) {
        this.package_type = data.data;
      } else {
        this.package_type = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  ngAfterViewInit() {
    this.loadPlanList(0, this.perpage);
  }

  async loadPlanList(pageIndex, perpage) {
    this.planList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'circle=' + this.circle + '&search=' + this.search + '&lead_source=' + this.lead_source + '&package_type=' + this.pkg_type;
    this.loading = true; this.loaded = false;
    await this.leadapi.getPlanLeadList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.planList = data.data;
      } else {
        this.planList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    }
  }
  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadPlanList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadPlanList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.circle = ''; this.search = ''; this.lead_source = ''; this.pkg_type = '';
    this.loadPlanList(0, 25);
  }
  openZoneDialog(plan_id) {
    const dialogRef = this.dialog.open(AddEditPlanLeadComponent, {
      width: '70%',
      height: '75%',
      data: plan_id
    });
  }

  //-------Export List-------//
  exportPlanList() {
    if (this.planList.length > 0) {
      let data = [];
      let titles = ['Name', 'Mobile', 'Circle', 'City', 'Lead Source', 'Package Type', 'Lead Status', 'Description', 'Created Date'];

      data.push(titles);

      for (let key in this.planList) {
        let extData = [this.planList[key].name, this.planList[key].mobile, this.planList[key].circle_name, this.planList[key].cityName,
        this.planList[key].sourceName, this.planList[key].planName, this.planList[key].lead_status_name, this.planList[key].description, formatDate(this.planList[key].created_on * 1000, 'dd MMM, yyyy hh:mm aa', 'en-US')];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'planlist' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Plan Data found!');
    }
  }


}
